export default function uniqueVendorProductNameDirective(
  $q,
  vmDataService
) {
  return {
    restrict: 'A',
    require: '?ngModel',
    link,
  };

  function link(scope, element, attributes, ngModel) {
    const productId = attributes.productId || -1;
    const vendorId = attributes.vendorId || -1;
    if (vendorId === '-1') {
      return $q.resolve();
    }
    ngModel.$asyncValidators.emVendorProductUniqueName = modelValue => vmDataService
      .checkProductExists(vendorId, productId, modelValue)
      .then((result) => {
        if (!result.data.result) {
          return $q.resolve();
        }
        return $q.reject();
      })
      .catch(() => $q.reject());
  }
}

export const name = 'emVendorProductUniqueName';

uniqueVendorProductNameDirective.$inject = [
  '$q',
  'vmDataService',
];
